import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.STOCK_ADJUST_SET_STOCK_ADJUST_LIST]: (state, payload) => {
    state.stockAdjustList = payload.data.stockAdjustList
  }
}

export default Mutations
